.combobox {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	min-height: 0;

	.selected {
		display: flex;
		gap: var(--size-3);
		flex-wrap: wrap;
		flex-shrink: 0;
		max-height: 6rem;
		overflow-y: auto;
		/* without this, chrome lets the wrapped chips scrolled out of view make the popover scroll too */
		contain: paint;

		> span {
			padding: 0 var(--size-3);
			font-weight: 500;
			display: flex;
			gap: var(--size-3);
			align-items: center;
			border-radius: var(--radius-md);
			background-color: var(--color-primary-background);
			color: var(--color-primary-foreground);

			&:has(.close:hover) {
				background-color: var(--color-error-background);
				color: var(--color-error-foreground);
			}

			.close {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: var(--size-2);
				border-radius: var(--radius-max);
				&:hover {
					background-color: var(--color-error-background);
				}
			}
		}
	}

	.results {
		display: flex;
		flex-direction: column;
		gap: 1px;
		overflow: hidden auto;

		min-width: 0;
		min-height: 0;
		min-height: calc-size(max-content, min(size, 6rem));
		margin-top: var(--size-2);
		background: var(--color-border);
		border: 1px solid var(--color-border);
		border-radius: var(--radius-md);

		> button {
			display: flex;
			text-align: left;
			align-items: center;
			justify-content: space-between;
			gap: var(--size-3);
			padding: var(--size-3) var(--size-4);
			background: var(--color-surface-hover);

			.result {
				min-width: 0;
				width: 100%;
			}

			> svg {
				color: var(--color-primary);
			}

			&:hover,
			&:focus-visible {
				color: var(--gray-200);
				background: var(--color-primary);
				--color-text-subtle: var(--blue-200);

				> svg {
					color: var(--gray-200);
				}
			}
		}

		.empty {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: var(--size-4);
			color: var(--color-text-subtle);
			font-size: var(--text-caption);
			background: var(--color-surface-hover);
		}
	}
}
